import React from "react";
import CredoraIcon from "./CredoraIcon";

const TOAST_META = {
  success: { icon: "check", iconClassName: "svg-fill", label: "Success" },
  error: { icon: "failed", iconClassName: "svg-stroke", label: "Error" },
  warning: { icon: "warning", iconClassName: "svg-stroke", label: "Warning" },
  info: { icon: "search", iconClassName: "svg-stroke", label: "Info" },
};

const CredoraToastContent = ({ type = "info", message }) => {
  const meta = TOAST_META[type] || TOAST_META.info;

  return (
    <div className={`credora-toast__content credora-toast__content--${type}`}>
      <span className={`credora-toast__icon credora-toast__icon--${type}`} aria-hidden>
        <CredoraIcon name={meta.icon} size={20} iconClassName={meta.iconClassName} />
      </span>
      <div className="credora-toast__text">
        <span className="credora-toast__label">{meta.label}</span>
        <p className="credora-toast__message mb-0">{message}</p>
      </div>
    </div>
  );
};

export default CredoraToastContent;
